import React from "react";

/* Ce context permet de partager l'information dans toute l'application. */

const FirebaseContext = React.createContext(null);

export default FirebaseContext;
